import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { FormattedMessage, useIntl } from 'react-intl'
import { useSelector } from 'react-redux'
import { Card, Container, Grid, Group, Stack } from '@mantine/core'
import { hasAccess } from '../../utils/helpers/rolesAccess'
import imgCircle from '../../assets/imgs/circulo-lineas.svg'
import { MODULES, GROUPS, METHOD } from '../../utils/constants/roles'
import HeaderView from '../../components/common/common-header/HeaderView'
import * as pathname from '../../routes/settings/pathname'
// import './settings.scss'
import css from './Settings.module.scss'
import { themeCfg } from '../../theme/theme.ts'
import AppSection from '../../component/layout/AppSection.tsx'

const Settings = () => {
  const intl = useIntl()

  const user = useSelector((state) => state.profile)
  const userRole = user?.resp?.role

  const cardsConfig = [
    {
      id: 'settings',
      cards: [
        { name: 'roles', path: pathname.rolesPathname.ROLES },
        { name: 'users', path: pathname.usersPathname.USERS },
      ],
    },
    {
      id: 'general',
      cards: [
        { name: 'mutuals', path: pathname.mutualsPathname.MUTUALS },
        { name: 'companies', path: pathname.companiesPathname.COMPANIES },
        { name: 'billables', path: pathname.generalPathname.BILLABLES },
        { name: 'inputs', path: pathname.generalPathname.INPUTS },
        { name: 'populations', path: pathname.generalPathname.POPULATIONS },
        { name: 'states', path: pathname.generalPathname.STATES },
      ],
    },
    {
      id: 'centers',
      cards: [
        { name: 'conventions', path: pathname.generalPathname.CONVENTIONS },
        { name: 'aspiratorTypes', path: pathname.centerPathname.ASPIRATOR },
        { name: 'comercialData', path: pathname.centerPathname.COMERCIAL_DATA },
        { name: 'gasTypes', path: pathname.centerPathname.GAS_TYPES },
        { name: 'heaterTypes', path: pathname.centerPathname.HEATER_TYPES },
        {
          name: 'otherTechnicsTypes',
          path: pathname.centerPathname.OTHER_TECNICS_TYPES,
        },
        { name: 'plattenTypes', path: pathname.centerPathname.PLATTEN_TYPES },
        { name: 'serviceTypes', path: pathname.centerPathname.SERVICES_TYPES },
        { name: 'soapTypes', path: pathname.centerPathname.SOAP_TYPES },
        { name: 'washingTypes', path: pathname.centerPathname.WASHING_TYPES },
        { name: 'trackTypes', path: pathname.centerPathname.TRACK_TYPES },
        {
          name: 'maintenanceTypes',
          path: pathname.centerPathname.MAINTENANCE_TYPES,
        },
      ],
    },
  ]

  // return (
  //     <div className="settings">
  //         {cardsConfig
  //             ?.map((block) => ({
  //                 ...block,
  //                 cards: block.cards.sort((a, b) =>
  //                     intl.formatMessage({ id: a.name }).localeCompare(
  //                         intl.formatMessage({ id: b.name })
  //                     )),
  //             }))
  //             ?.map((block) => (
  //                 <div className="block" key={`block-${block?.id}`}>
  //                     <h2 className="title__container">
  //                         {intl.formatMessage({ id: block?.id })}
  //                     </h2>
  //                     <div className="grid">
  //                         {block?.cards?.map((card, idx) => (
  //                             <Link
  //                                 className="link-item"
  //                                 to={card?.path}
  //                                 key={idx}
  //                             >
  //                                 <FormattedMessage id={card?.name} />
  //                             </Link>
  //                         ))}
  //                     </div>
  //                 </div>
  //             ))}
  //     </div>
  // )

  useEffect(() => {
    const mainContentView = document.querySelector('.mantine-AppShell-main')
  }, [])

  return (
    <AppSection>
      <Stack gap="xl" w="100%" p={themeCfg?.default?.padding}>
        {cardsConfig
          ?.map((block) => ({
            ...block,
            cards: block.cards.sort((a, b) =>
              intl
                .formatMessage({ id: a.name })
                .localeCompare(intl.formatMessage({ id: b.name })),
            ),
          }))
          ?.map((block) => (
            <>
              <h2 className="title__container">
                {intl.formatMessage({ id: block?.id })}
              </h2>
              <Grid w="100%" gap="xl" columns={9}>
                {block?.cards?.map((card, idx) => (
                  <Grid.Col span={{ base: 9, xs: 3, xl: 1 }}>
                    <Link to={card?.path} key={idx}>
                      <Card bg="moure-blue" h={80} p={0} c="white" radius="md">
                        <Group
                          w="100%"
                          h="100%"
                          className={css.cardBody}
                          p={themeCfg?.default?.padding}
                          justify="flex-end"
                          align="flex-end"
                          style={{ textAlign: 'right' }}
                        >
                          <FormattedMessage id={card?.name} />
                        </Group>
                      </Card>
                    </Link>
                  </Grid.Col>
                ))}
              </Grid>
            </>
          ))}
      </Stack>
    </AppSection>
  )
}
export default Settings
